const firebaseConfig = {
    apiKey: "AIzaSyAI-ZPewqoDtKyYWquLSO7d7Y82Fg4yx1g",
    authDomain: "riding-hero.firebaseapp.com",
    projectId: "riding-hero",
    storageBucket: "riding-hero.appspot.com",
    messagingSenderId: "973001602181",
    appId: "1:973001602181:web:472ac41806aba571e5a5ec"
  };

  export default firebaseConfig;